module.exports = __webpack_public_path__ + "img/11-add-fav.9670ea30.svg";